var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalProceedings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "64px",
    height: "55px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 64 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plan_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M8 1l38 0c1,0 2,1 2,2l0 40 -3 4 3 2 0 2c0,1 -1,2 -2,2l-38 0c-1,0 -2,-1 -2,-2l0 -48c0,-1 1,-2 2,-2z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 13,
    y1: 23,
    x2: 41,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 13,
    y1: 28,
    x2: 26,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 13,
    y1: 32,
    x2: 26,
    y2: 32
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    transform: "matrix(2.79952 1.80624 -1.81335 2.09575 35.0236 27.6495)",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    transform: "matrix(2.56908 1.65488 -1.50047 2.18889 26.858 40.7385)",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M44 37c-3,-2 -6,-4 -9,-6 -4,4 -6,5 -7,10 3,2 6,3 8,5 5,-3 6,-6 7,-10z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    transform: "matrix(2.12841 1.34924 -1.41433 2.03046 42.5639 41.5732)",
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E4887",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    d: "M47 43l9 6c1,1 2,3 1,4l0 0c-1,1 -3,2 -4,1l-9 -6 3 -5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1366114612416"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8CC63F",
    d: "M42 9c0,0 0,1 0,1 0,4 -3,7 -7,7 0,0 0,0 -1,0 0,0 0,-1 0,-1 0,-4 3,-7 7,-7 0,0 0,0 1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DB848",
    d: "M37 16c-1,0 -1,0 -2,0 -4,0 -7,-4 -7,-7 0,-3 1,-5 4,-6 -1,2 -2,5 1,7 3,1 4,3 4,6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A950",
    d: "M37 16l0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0,0 0,0 0,0l0 0c0,0 0,0 0,0l0 0c0,0 0,0 0,0l0 0c0,0 0,0 0,0l0 0 0 0c0,0 0,0 0,0l0 0 0 0 0 0c0,0 0,0 0,0l0 0 0 0 0 0c0,0 0,0 0,0 0,0 0,0 -1,0 0,0 0,-1 0,-1 0,-1 0,-3 1,-4 1,1 2,2 1,4z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EE3A43",
    cx: 36,
    cy: 7,
    r: 2
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 42,
    y1: 43,
    x2: 45,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 27,
    y1: 42,
    x2: 37,
    y2: 49
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    strokeMiterlimit: 22.9256,
    x1: 35,
    y1: 29,
    x2: 46,
    y2: 36
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalProceedings);
export default __webpack_public_path__ + "static/media/legalProceedings.f4ad20f14227fe12aa3dc2b622a497bc.svg";
export { ForwardRef as ReactComponent };